import { createActions } from 'reduxsauce';
const { Types, Creators } = createActions({
  getKnowledge: ['params'],
  getKnowledgeSuccess: ['dataTopFeatures'],
  getKnowledgeFail: [],
  getMoreKnowledge: ['params'],
  getMoreKnowledgeSuccess: ['dataTopFeatures'],
  getIncidentTicketList: ['params'],
  getIncidentTicketListSuccess: ['dataIncident'],
  getRequestTicketList: ['params'],
  getRequestTicketListSuccess: ['dataRequest'],
});
export const KnowledgeTypes = Types;
export default Creators;
